<template>
  <div class="task-bar-button">
    <tooltip
      :delay="500"
      placement="left"
      :transfer="false"
      :content="tooltipContent"
    >
      <template v-if="showBadge">
        <badge dot :type="badgeType">
          <icon @click="clickHandler" :size="size" :type="icon" />
        </badge>
      </template>
      <template v-else>
        <icon @click="clickHandler" :size="size" :type="icon" />
      </template>
    </tooltip>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '24'
    },
    showBadge: {
      type: Boolean,
      required: true
    },
    badgeType: {
      type: String,
      default: 'primary'
    },
    clickHandler: {
      type: Function,
      required: true
    },
    tooltipContent: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less">
.task-bar-button {
  .ivu-icon {
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    vertical-align: middle;

    &:hover {
      color: rgba(255, 255, 255, 0.4);
    }
  }
}
</style>
